//useGlobalVariables.js

export const usersCollection = 'users';
export const globalSettingsCollection = 'globalSettings';
export const profilePicturespath = 'profilePictures';
export const appName = 'TrendzTube';

/**
 * Default global settings
 * Only current plans used in the app are defined here for dynamic usage.
 */
export const defaultGlobalSettings = {
  createdAt: new Date().toString(),
  gracePeriod: 5,
  globalDiscount: '10%',
  yearlyPlanDiscount: '10%',
  superAlert: {
    showAlert: false,
    message: '',
    alertType: 'info',
  },
  plans: {
    free: {
      name: 'Free Plan',
      description: '18 video ideas',
      price: 0,
      visible: true,
      mostPopular: false,
      generationLimit: 3, // 3 generations per month
      position: 1,
      features: [
        '3 generations per month',
        '18 video ideas total',
        'Basic AI recommendations',
        'Market Insights',
        'Email support',
      ],
      interval: 'month'
    },
    trendztubeStarter: {
      id: '688476', //Test: '671513', //from lemon squeezy
      name: 'TrendzTube Starter',
      description: '1000 video ideas',
      price: 3.99,
      visible: true,
      mostPopular: false,
      generationLimit: 100, // 100 generations per month
      position: 2,
      features: [
        '100 generations per month',
        '1000 video ideas total',
        'Enhanced AI recommendations',
        'Market Insights',
        'Email support'
      ],
      interval: 'month'
    },
    trendztubePro: {
      id: '688446',  // Test: '671519', //from lemon squeezy
      name: 'TrendzTube Pro',
      description: '3000 video ideas',
      price: 13.99,
      visible: true,
      mostPopular: true,
      generationLimit: 500, // 500 generations per month
      position: 3,
      features: [
        '500 generations per month',
        '3000 video ideas total',
        'Premium AI recommendations',
        'Market Insights',
        '24/7 priority support'
      ],
      interval: 'month'
    }
  }
};